export const MAX_SIZE_MB = 1;

export const SECRET_KEY = process.env.ENCRYPTION_SECRET_KEY || "sdfhbe8374t5c84753487@*&y";
